import React from 'react';

import PropTypes from 'prop-types';

import SubmittableField from 'components/application/SubmittableField';
import Toggleable from 'components/application/Toggleable';

export default function ToggleableField({
  autoFocus,
  isSubmitDisabled,
  isToggled,
  onCancel,
  onChange,
  onSubmit,
  onToggle,
  placeholderText,
  submitButtonText,
  toggleableItem,
  value,
}) {
  return (
    <Toggleable
      isToggled={isToggled}
      primary={toggleableItem}
      secondary={
        <SubmittableField
          autoFocus={autoFocus}
          isSubmitDisabled={isSubmitDisabled}
          onCancel={onCancel}
          onChange={onChange}
          onSubmit={onSubmit}
          placeholderText={placeholderText}
          submitButtonText={submitButtonText}
          value={value}
        />
      }
      setIsToggled={onToggle}
    />
  );
}

ToggleableField.propTypes = {
  autoFocus: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  isToggled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  submitButtonText: PropTypes.string.isRequired,
  toggleableItem: PropTypes.node,
  value: PropTypes.string,
};
